import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';

import { objectToFormData } from 'utils/helpers';
import { fetchInboxMessage, starMessage } from 'store/slices';

import Card from 'components/Layout/Card'
import TabLayout from 'components/Layout/TabLayout'
import { findIndex } from 'lodash';
import Compose from 'pages/Common/InboxNotifications/Compose';
import EmailDetails from 'pages/Common/InboxNotifications/EmailDetails';
import List from 'pages/Common/InboxNotifications/List';
import NewList from 'pages/Common/InboxNotifications/List/NewList';

const tabs = [
    // { key: 'inbox', label: 'Inbox' },
    { key: 'compose', label: 'Compose' },
    { key: 'sent-messages', label: 'Sent Messages' },
    // { key: 'starred-messages', label: 'Starred Messages' },
];

const ResourceInbox = ({ paperData }) => {
    const dispatch = useDispatch();
    const [childTabType, setChildTabType] = useState('compose');
    const [isLoading, setIsLoading] = useState(true);
    const [msgList, setMsgList] = useState([]);
    const [deleteIds, setDeleteIds] = useState([]);

    const getType = () => {
        switch (childTabType) {
            case 'inbox':
                return 'incoming';
            case 'sent-messages':
                return 'outgoing';
            case 'starred-messages':
                return 'starred';

            default:
                return '';
        }
    };
    const handelStarMessage = async (data) => {
        const formData = objectToFormData(data);
        const response = await dispatch(starMessage(formData));
        if (response?.status === 200) {
            const newList = [...msgList];
            const index = findIndex(newList, ['id', data.id]);
            newList[index].is_starred = data.status;
            setMsgList(newList);
        }
    };

    const getEmailList = async () => {
        setMsgList([]);
        const formData = objectToFormData({ type: getType(), abstract_id: Number(paperData?.id)});
        const response = await dispatch(fetchInboxMessage(formData));
        setMsgList(response?.data || []);
        setIsLoading(false);
    };

    useEffect(() => {
        setDeleteIds([]);
        setMsgList([]);
        if (
            childTabType !== 'compose'
        ) {
            setIsLoading(true);
            getEmailList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [childTabType]);

    const [selectedMail, setSelectedMail] = useState(null);
    const [showDetails, setShowDetails] = useState(false);

    return (
        <Card >
            <div className="cps-20 cpe-20 cpt-10">
                <TabLayout
                    tabs={tabs}
                    activeKey={childTabType}
                    onChange={(key) => {
                        setChildTabType(key);
                        setShowDetails(false);
                    }}
                />
            </div>

            {showDetails ?
                <>
                    <div className="cps-20 cpe-20 cpt-10 text-14-300">
                        Detail View
                    </div>
                    <EmailDetails emailId={selectedMail.id} emailKey={selectedMail.key} setShowDetails={setShowDetails} />
                </> :
                <>
                    {childTabType === 'compose' &&
                        <Compose userData={{
                            user_id: paperData?.user_id,
                            name: paperData?.authorName,
                            paper_title: paperData?.paperTitle,
                            paper_id: paperData?.paperId,
                            abstract_id: Number(paperData?.id),
                            abstract_notification: true
                        }}
                        />}

                    {/* {childTabType === 'inbox' && (
                        <List
                            listType={childTabType}
                            isLoading={isLoading}
                            msgList={msgList}
                            deleteIds={deleteIds}
                            // handelDeleteId={handelDeleteId}
                            // handelDeleteMessage={handelDeleteMessage}
                            handelStarMessage={handelStarMessage}
                            isResourceMail={true}
                            onOpenResourceMail={({ id, key }) => {
                                setSelectedMail({ id, key });
                                setShowDetails(true);
                            }}
                        />)} */}

                    {childTabType === 'sent-messages' && (
                        <NewList
                            listType={childTabType}
                            isLoading={isLoading}
                            msgList={msgList}
                            deleteIds={deleteIds}
                            // handelDeleteId={handelDeleteId}
                            // handelDeleteMessage={handelDeleteMessage}
                            handelStarMessage={handelStarMessage}
                            isResourceMail={true}
                            onOpenResourceMail={({ id, key }) => {
                                setSelectedMail({ id, key });
                                setShowDetails(true);
                            }}
                        />
                    )}

                    {/* {childTabType === 'starred-messages' && (
                        <List
                            listType={childTabType}
                            isLoading={isLoading}
                            msgList={msgList}
                            deleteIds={deleteIds}
                            // handelDeleteId={handelDeleteId}
                            // handelDeleteMessage={handelDeleteMessage}
                            handelStarMessage={handelStarMessage}
                            isResourceMail={true}
                            onOpenResourceMail={({ id, key }) => {
                                setSelectedMail({ id, key });
                                setShowDetails(true);
                            }}
                        />
                    )} */}

                </>
            }
        </Card>
    )
}

export default ResourceInbox
